import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, provideDefaultConfig, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';

import { AimoTextBannerComponent } from './aimo-text-banner.component';

@NgModule({
    imports: [CommonModule, RouterModule, IconModule, MediaModule, UrlModule, I18nModule],
    declarations: [AimoTextBannerComponent],
    exports: [AimoTextBannerComponent],
    providers: [
        provideDefaultConfig(<CmsConfig>{
            cmsComponents: {
                AimoTextBannerComponent: {
                    component: AimoTextBannerComponent,
                },
            },
        }),
    ],
})
export class AimoTextBannerModule {}
